const defaultFormat = {
  minute: " '",
  hour: "h",
}

function delayFormat(delay: number, format: { minute: string; hour: string } = defaultFormat): string {
  const delayInHourSteps = Math.floor(delay / 60)

  if (delay < 30) {
    return `+${delay}${format.minute}`
  }

  if (delayInHourSteps < 2) {
    return `+${Math.floor(delay / 30) * 30}${format.minute}`
  }

  return `+${delayInHourSteps}${format.hour}`
}

export { delayFormat }
